<template>
  <a-table
    :size="tableDensity"
    :loading="loading"
    :pagination="pagination"
    @change="handleTableChange"
    rowKey="spiderId"
    :columns="showColumns"
    :data-source="tableData"
  >
    <span slot="index" slot-scope="text, record, index">{{ index + 1 }}</span>

    <span slot="spiderId" slot-scope="text, record">
      <a-tooltip>
        <template slot="title"> {{ record.spiderId }} </template>
        <span>
          {{ record.spiderId }}
        </span>
      </a-tooltip>

      <a-tooltip>
        <template slot="title"> 复制 </template>
        <a
          href="javascript:;"
          v-clipboard:copy="text"
          v-clipboard:success="onCopy"
          v-clipboard:error="onCopyError"
        >
          <a-icon type="copy" />
        </a>
      </a-tooltip>
    </span>

    <span slot="spiderName" slot-scope="text, record">
      <Avatar :url="record.headImage" :type="record.spiderClassType" />

      <a-tooltip>
        <template slot="title"> {{ record.spiderName }} </template>
        <span>
          {{ record.spiderName }}
        </span>
      </a-tooltip>

      <a-tooltip>
        <template slot="title"> 复制 </template>
        <a
          href="javascript:;"
          v-clipboard:copy="text"
          v-clipboard:success="onCopy"
          v-clipboard:error="onCopyError"
        >
          <a-icon type="copy" />
        </a>
      </a-tooltip>
    </span>
    <span slot="spiderLevel" slot-scope="deep">
      <span v-if="deep === -1">全部</span>
      <span v-else>{{ deep }}层</span>
    </span>

    <span slot="spiderClassType" slot-scope="type">
      <span v-if="type === 'toutiao'">头条</span>
      <span v-if="type === 'api'">云采集</span>
      <span v-if="type === 'document'">文献</span>
      <span v-if="type === 'wechat'">微信公众号</span>
    </span>

    <span slot="execType" slot-scope="text, record">
      <a-badge v-if="record.execType === 1" color="green" text="运行" />
      <a-badge v-else-if="!record.execType" color="orange" text="待运行" />
      <a-badge v-else-if="record.execType === -1" color="red" text="暂停" />
    </span>

    <span slot="action" slot-scope="text, record">
      <a-popconfirm
        v-if="record.execType === -1 || record.execType === 0"
        title="确定要开始调度吗?"
        @confirm="() => handleExecSpiderById(record)"
      >
        <a-button type="link">调度 </a-button>
      </a-popconfirm>
      <a-popconfirm
        v-else-if="record.execType === 1"
        title="确定要停止调度吗?"
        @confirm="() => handleStopSpiderById(record)"
      >
        <a-button type="link">暂停 </a-button>
      </a-popconfirm>
      <a-divider type="vertical"></a-divider>
      <a-button type="link" @click="handleHandExec(record)">执行 </a-button>

      <a-divider type="vertical"></a-divider>
      <a-button @click="handleEdit(record)" type="link">编辑 </a-button>
      <a-divider type="vertical"></a-divider>
      <a-button @click="handleInfo(record)" type="link">详情 </a-button>
      <a-divider type="vertical"></a-divider>

      <a-popconfirm title="确定要删除吗?" @confirm="onDelete(record)">
        <a-button type="link">删除 </a-button>
      </a-popconfirm>
    </span>
  </a-table>
</template>

<script>
import {
  querySpiderApiListApi,
  stopSpiderByIdApi,
  deleteSpiderItemApi,
  execSpiderApiByIdApi,
  execApiItemApi
} from '@/api/Site/Manage'
import tableSettingToStoreMixin from '@/mixin/tableSettingToStroe'
import { deleteSiteApi } from '@/api/Site/Approval'
import Avatar from '../components/Avatar.vue'
export default {
  props: {
    tableDensity: String
  },
  mixins: [tableSettingToStoreMixin()],
  data() {
    return {
      search: {
        spiderName: '',
        spiderId: '',
        country: undefined,
        lang: undefined,
        spiderClassId: '',
        execType: undefined,
        orderKey: '',
        isAsc: false
      },
      pagination: {
        current: 1,
        pageSize: 10,
        showTotal: (total) => `共 ${total} 条`,
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        size: 'default'
      },
      spiderClassMap: {},
      langMap: {},
      tableData: [],
      columns: [
        {
          title: '序号',
          width: 60,
          align: 'center',
          show: true,
          scopedSlots: { customRender: 'index' }
        },
        {
          title: 'ID',
          dataIndex: 'spiderId',
          show: true,
          ellipsis: true,
          scopedSlots: { customRender: 'spiderId' }
        },
        {
          title: '站点名称',
          dataIndex: 'spiderName',
          sorterFiled: 'spider_name',
          show: true,
          defaultSortOrder: '',
          sorter: true,
          ellipsis: true,
          scopedSlots: { customRender: 'spiderName' }
        },
        {
          title: '类别',
          dataIndex: 'spiderClassType',
          align: 'center',
          show: true,
          width: 100,
          scopedSlots: { customRender: 'spiderClassType' }
        },
        {
          title: '国家',
          dataIndex: 'countryName',
          show: true,
          width: 80,
          ellipsis: true
        },
        {
          title: '语言',
          dataIndex: 'langName',
          show: true,
          width: 110,
          ellipsis: true
        },
        {
          title: '爬取深度',
          dataIndex: 'spiderLevel',
          show: true,
          width: 90,
          scopedSlots: { customRender: 'spiderLevel' }
        },
        {
          title: '执行状态',
          dataIndex: 'execType',
          show: true,
          width: 90,
          scopedSlots: { customRender: 'execType' },
          align: 'center'
        },
        {
          title: '操作',
          key: 'action',
          show: true,
          scopedSlots: { customRender: 'action' },
          width: 320,
          align: 'center'
        }
      ],
      loading: false,
      visible: false
    }
  },
  components: {
    Avatar
  },
  computed: {
    showColumns() {
      return this.columns.filter((item) => item.show)
    }
  },

  activated() {
    // this.querySpiderList()
  },

  methods: {
    // 复制成功时的回调函数
    onCopy(e) {
      this.$message.success('已复制')
    },
    // 复制失败时的回调函数
    onCopyError(e) {
      this.$message.error('复制失败')
    },
    copy: function () {
      var _this = this
      var clipboard = new Clipboard('#copy_text')

      clipboard.on('success', (e) => {
        message.success('复制成功')
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', (e) => {
        // 不支持复制
        Message({
          message: '该浏览器不支持自动复制',
          type: 'warning'
        })
        // 释放内存
        clipboard.destroy()
      })
    },

    handleEdit({ spiderId, spiderClassType }) {
      this.$router.push({
        name: 'site_create_form',
        query: {
          spiderId,
          type: spiderClassType,
          route: 'site_manage'
        }
      })
    },

    handleInfo({ spiderId, spiderClassType }) {
      this.$router.push({
        name: 'site_info',
        query: {
          spiderId,
          type: spiderClassType
        }
      })
    },

    handleTableChange(pagination, filters, { order, column }) {
      this.search.orderKey = column ? column.sorterFiled : ''
      this.search.isAsc = order === 'ascend'
      this.pagination = pagination
      this.querySpiderList()
    },

    async handleSearch(condition = {}) {
      this.pagination.current = 1
      this.search = { ...this.search, ...condition }
      await this.querySpiderList()
    },

    async querySpiderList() {
      let query = {
        pn: this.pagination.current,
        pageSize: this.pagination.pageSize,
        ...this.search
      }

      this.loading = true
      let res = await querySpiderApiListApi(query)
      this.loading = false
      let { code, msg, data, extra } = res
      if (code == '200') {
        this.tableData = data
        this.pagination.total = extra.page.pageCount || 0
      } else {
        this.$message.error(msg)
      }
    },

    async handleDelete({ spiderId }) {
      let res = await deleteSpiderItemApi({
        spiderId
      })
      let { code, msg } = res
      if (code == '200') {
        this.$message.success(msg)
        this.querySpiderList()
      } else {
        this.$message.error(msg)
      }
    },

    async handleStopSpiderById({ spiderId }) {
      let res = await stopSpiderByIdApi({
        spiderId
      })
      let { code, msg } = res
      if (code == '200') {
        this.$message.success(msg)
        this.querySpiderList()
      } else {
        this.$message.error(msg)
      }
    },

    async handleExecSpiderById({ spiderId }) {
      let res = await execSpiderApiByIdApi({
        spiderId
      })
      let { code, msg } = res
      if (code == '200') {
        this.$message.success(msg)
        this.querySpiderList()
      } else {
        this.$message.error(msg)
      }
    },

    async handleHandExec(record) {
      // 弹框询问是否全量调度（全量调度不过滤系统中已存在的数据）
      const confirm = this.$confirm({
        content: '是否进行单次全量调度（全量调度不过滤系统中已存在的数据）',
        okText: '非全量调度',
        cancelText: '全量调度',
        maskClosable: true,
        onOk: () => {
          this._handleHandExec(record, false)
        },
        onCancel: (e) => {
          if (typeof e === 'object' && e.triggerCancel) {
            confirm.destroy()
          } else {
            this._handleHandExec(record, true)
            return Promise.resolve()
          }
        }
      })
    },

    async _handleHandExec({ spiderId, spiderLevel }, isAll) {
      let res = await execApiItemApi({
        spiderId,
        spiderLevel,
        isAll
      })
      let { code, msg } = res
      if (code == '200') {
        this.$message.success(msg)
      } else {
        this.$message.error(msg)
      }
    },

    async onDelete(record) {
      var param = {}
      param['spiderId'] = record['spiderId']
      param['spiderClassId'] = record['spiderClassId']
      const { code, msg } = await deleteSiteApi(param)
      if (code !== 200) {
        this.$message.error(msg)
        return
      }

      this.$message.success('操作成功')
      this.querySpiderList()
    }
  }
}
</script>

<style lang="less" scoped></style>
